import { Directive, ElementRef, forwardRef, Injector, Input, NgZone, OnInit, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { AppConfig } from '../utils/app-config.service';

declare const grecaptcha: any;

declare global {
    interface Window {
        grecaptcha: any;
        reCaptchaLoad: () => void;
    }
}

@Directive({
    selector: '[thr-recaptcha]',
    exportAs: 'recaptcha',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RecaptchaDirective),
            multi: true,
        },
    ],
})
export class RecaptchaDirective implements OnInit, ControlValueAccessor {
    @Input()
    key: string = AppConfig.settings.reCaptchaKey;

    @Input()
    lang = 'es';

    onTouched: () => void = () => {};
    onChange: (value: any) => void = () => {};

    constructor(private element: ElementRef, private injector: Injector, private ngZone: NgZone, private renderer: Renderer2) {}

    ngOnInit(): void {
        this.registerReCaptchaCallback();
        this.addScript();
    }

    private registerReCaptchaCallback() {
        window.reCaptchaLoad = () => {
            grecaptcha.ready(() => {
                this.refresh();
            });
        };
    }

    refresh(): Promise<void> {
        return new Promise((resolve, reject) => {
            grecaptcha.execute(this.key).then((token) => {
                this.onSuccess(token);

                resolve();
            });
        });
    }

    private onSuccess(token: string) {
        this.ngZone.run(() => {
            this.onChange(token);
            this.onTouched();
        });
    }

    private addScript() {
        const script = document.createElement('script');

        script.src = `https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad&render=${this.key}&hl=${this.lang}`;
        script.async = true;
        script.defer = true;

        this.renderer.appendChild(document.body, script);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {}

    writeValue(obj: any): void {}
}
